export { default as Evaluation } from "./main";

import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  routes,
  Anchors,
};
